import React from "react";
import InputText from "../../shared/input-text";
import styles from "./styles.css";
import banner from "./images/banner-bg.png";

const CdpTradeInBannerRevamp = () => {
    return (
        <div styleName={"styles.outer"}>
            <div styleName={"styles.leftWrapper"}>
                <p styleName={"styles.heading"}>Do you have a car to trade in?</p>
                <div styleName={"styles.customInputStyle"}>
                    <InputText placeholder="ENTER REGO" />
                    <span styleName={"styles.circle"}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none">
                            <circle cx="2" cy="2" r="2" fill="#D9D9D9" />
                            <path d="M3.20078 1.77407H2.25019V0.799951H1.75137V1.77407H0.800781V2.22583H1.75137V3.19995H2.25019V2.22583H3.20078V1.77407Z" fill="#5B5B5B" />
                        </svg>
                    </span>
                    <span styleName={"styles.circle"}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none">
                            <circle cx="2" cy="2" r="2" fill="#D9D9D9" />
                            <path d="M3.20078 1.77407H2.25019V0.799951H1.75137V1.77407H0.800781V2.22583H1.75137V3.19995H2.25019V2.22583H3.20078V1.77407Z" fill="#5B5B5B" />
                        </svg>
                    </span>
                    <span styleName={"styles.circle"}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none">
                            <circle cx="2" cy="2" r="2" fill="#D9D9D9" />
                            <path d="M3.20078 1.77407H2.25019V0.799951H1.75137V1.77407H0.800781V2.22583H1.75137V3.19995H2.25019V2.22583H3.20078V1.77407Z" fill="#5B5B5B" />
                        </svg>
                    </span>
                    <span styleName={"styles.circle"}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none">
                            <circle cx="2" cy="2" r="2" fill="#D9D9D9" />
                            <path d="M3.20078 1.77407H2.25019V0.799951H1.75137V1.77407H0.800781V2.22583H1.75137V3.19995H2.25019V2.22583H3.20078V1.77407Z" fill="#5B5B5B" />
                        </svg>
                    </span>
                </div>
            </div>
            <div styleName={"styles.rightWrapper"}>
                <img src={banner} />
            </div>
        </div>
    );
};

export default CdpTradeInBannerRevamp;
